let category = null
export default {
    category
}